// extracted by mini-css-extract-plugin
module.exports = {"body":"ChangePriceModal_body__1weYz","priceInput":"ChangePriceModal_priceInput__2o7su","submitButton":"ChangePriceModal_submitButton__11B6o"};